module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "large": true
    },
    model: {
      value: (_vm.value.show),
      callback: function($$v) {
        _vm.value.show = $$v
      },
      expression: "value.show"
    }
  }, [_c('div', {
    slot: "content"
  }, [_c('div', {
    staticClass: "ls-modal-header"
  }, [_c('button', {
    attrs: {
      "close-modal": "",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "ls-modal-title"
  }, [_vm._v(_vm._s(_vm.$t('invoices.labels.orders')))])]), _vm._v(" "), _c('div', {
    staticClass: "ls-modal-body"
  }, [_c('table', {
    staticClass: "ls-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "ls-txt-center"
  }, [_vm._v(_vm._s(_vm.$t('invoices.attributes.id')))]), _vm._v(" "), _c('th', {
    staticClass: "ls-txt-center"
  }, [_vm._v(_vm._s(_vm.$t('invoices.attributes.amount_due')))]), _vm._v(" "), _c('th', {
    staticClass: "ls-txt-center"
  }, [_vm._v(_vm._s(_vm.$t('invoices.attributes.status')))]), _vm._v(" "), _c('th', {
    staticClass: "ls-txt-center"
  }, [_vm._v(_vm._s(_vm.$t('invoices.orders.payment_method')))]), _vm._v(" "), _c('th', {
    staticClass: "ls-txt-center"
  }, [_vm._v(_vm._s(_vm.$t('invoices.attributes.created_at')))]), _vm._v(" "), _c('th', {
    staticClass: "ls-txt-center"
  }, [_vm._v(_vm._s(_vm.$t('invoices.attributes.due_date')))]), _vm._v(" "), (_vm.hasPermission()) ? _c('th', {
    staticClass: "ls-txt-center"
  }, [_vm._v(_vm._s(_vm.$t('orders.attributes.external_code')))]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.value.orders), function(order) {
    return _c('tr', [_c('td', {
      staticClass: "ls-txt-center"
    }, [_vm._v(_vm._s(order.id))]), _vm._v(" "), _c('td', {
      staticClass: "ls-txt-center"
    }, [_vm._v(_vm._s(_vm.$parent.money.parseViewValue(order.price)))]), _vm._v(" "), _c('td', {
      staticClass: "ls-txt-center"
    }, [_vm._v(_vm._s(_vm.statusMessage(order)))]), _vm._v(" "), _c('td', {
      staticClass: "ls-txt-center"
    }, [_vm._v(_vm._s(order.payment_method))]), _vm._v(" "), _c('td', {
      staticClass: "ls-txt-center"
    }, [_vm._v(_vm._s(order.generated_with_success ? _vm.$parent.date.parseDate(order.created_at) : '-'))]), _vm._v(" "), _c('td', {
      staticClass: "ls-txt-center"
    }, [_vm._v(_vm._s((order.payment_method_type === 'billet' && order.generated_with_success) ? _vm.$parent.date.parseDate(order.due_date) : '-'))]), _vm._v(" "), (_vm.hasPermission()) ? _c('td', {
      staticClass: "ls-txt-center"
    }, [_vm._v(_vm._s(order.external_code))]) : _vm._e()])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "ls-modal-footer"
  }, [(_vm.value.buttonVerify) ? _c('button', {
    staticClass: "ls-btn ls-float-right ls-btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getOrders()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('invoices.buttons.verify_orders')))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "ls-btn",
    attrs: {
      "close-modal": "",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('application.button.close')))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26d6d340"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/invoices/components/ModalOrders.vue
// module id = 744
// module chunks = 1